import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { MCPConfigSnippet } from '../../../../src/components/Product/MCP/MCPConfig';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ol>
      <li parentName="ol">{`Open `}<a parentName="li" {...{
          "href": "https://cursor.com"
        }}>{`Cursor`}</a>{` and navigate to `}<strong parentName="li">{`Cursor Settings > Tools & Integrations`}</strong></li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New MCP Server`}</strong></li>
      <li parentName="ol">{`Update `}<inlineCode parentName="li">{`mcp.json`}</inlineCode>{` with the following configuration:`}</li>
    </ol>
    <MCPConfigSnippet variant="cursor" mdxType="MCPConfigSnippet" />
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol"><strong parentName="li">{`Save`}</strong>{` the configuration file`}</li>
      <li parentName="ol">{`You should see `}<strong parentName="li">{`posthog`}</strong>{` under `}<strong parentName="li">{`MCP Tools`}</strong>{` with a green status`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      